<script setup lang="ts">
import type { Tab } from '@/components/profile/follow/ProfileFollowModal.vue'
import type { Follower } from '@/services/profile'
import { useInfiniteScroll } from '@vueuse/core'
import UserRow from '@/components/profile/follow/UserRow.vue'
import UserRowSkeleton from '@/components/profile/follow/UserRowSkeleton.vue'
import { fetchFollowersOf, fetchFollowing } from '@/services/profile'

const props = defineProps<{
  totalCount: number
  type: Tab
}>()

const route = useRoute()

const vList = ref<Follower[]>([])
const offset = computed(() => vList.value.length)
const limit = 10
const el = ref<HTMLElement>()
const loadingSkeletonItems = computed(() => Math.min(4, props.totalCount))
const isLoading = ref(false)

async function fetchNextPage() {
  if (offset.value >= props.totalCount) {
    return
  }

  if (offset.value === 0) {
    isLoading.value = true
  }
  if (props.type === 'following') {
    const { following } = await fetchFollowing(route.params.id as string, {
      limit,
      offset: offset.value,
    })
    vList.value.push(...following)
  }
  else {
    const { followers } = await fetchFollowersOf(route.params.id as string, {
      limit,
      offset: offset.value,
    })
    vList.value.push(...followers)
  }

  isLoading.value = false
}

// onMounted(() => {
//   if (props.totalCount > 0) {
//     fetchNextPage()
//   }
// })

useInfiniteScroll(el, fetchNextPage, { distance: limit })
</script>

<template>
  <div
    v-if="isLoading"
    class="flex flex-col gap-5"
  >
    <UserRowSkeleton
      v-for="(_, index) in loadingSkeletonItems"
      :key="index"
    />
  </div>
  <div
    v-else-if="totalCount > 0"
    ref="el"
    class="flex flex-col gap-5 max-h-[400px] overflow-y-auto"
  >
    <UserRow
      v-for="user in vList"
      :key="user.address"
      :user="user"
    />
  </div>
  <div
    v-else
    class="text-center text-gray-600 dark:text-gray-400"
  >
    <span>Not Following Anyone Yet</span>
  </div>
</template>
